import {createSelector} from 'reselect';
import {getCombinedData, getCombinedConfiguredItemStats, getValidConfiguredItems, getTotalIndexed, getTotalDataPerDay, getCiscoRatio} from '../../utils/statsUtils';

// Getters for full data sets
const getConfiguredItems = (state) => state.dsaConfig && state.dsaConfig.configuredItems || [];
const getConfiguredItemAnswers = (state) => state.dsa && state.dsa.dsaConfiguredItems || [];
const getDSAAreaIds = (state) => state.dsa && state.dsa.dsaAreas && state.dsa.dsaAreas.map(a => a.area) || [];

export const makeGetAreaOverlapTotals = () => {
  return createSelector(
    [getDSAAreaIds, getConfiguredItems, getConfiguredItemAnswers],
    (dsaAreaIds, questions, answers) => {

      let areaOverlapTotals = {};
      let combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      let validConfiguredItems = getValidConfiguredItems(combinedConfiguredItems);

      dsaAreaIds.forEach(areaId => {
        let areaOverlappingConfiguredItems = validConfiguredItems.filter(item => item.overlap.indexOf(areaId) >= 0);
        areaOverlapTotals[areaId] = getCombinedConfiguredItemStats(areaOverlappingConfiguredItems);

      });

      return areaOverlapTotals;
    }
  );
};

export const makeGetAreaOverlap = () => {
  return createSelector(
    [getDSAAreaIds, getConfiguredItems, getConfiguredItemAnswers],
    (dsaAreaIds, questions, answers) => {
      let overlap = {
        1: {}, 2: {}, 3: {}, 4: {}, 5: {}
      };
      let combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      let validConfiguredItems = getValidConfiguredItems(combinedConfiguredItems);
      calculateAreaOverlap(overlap, dsaAreaIds, validConfiguredItems);
      return overlap;
    }
  );
};

export const makeGetNewCustomerOverlap = () => {
  return createSelector(
    [getDSAAreaIds, getConfiguredItems, getConfiguredItemAnswers],
    (dsaAreaIds, questions, answers) => {
      let overlap = {
        1: {}, 2: {}, 3: {}, 4: {}, 5: {}
      };
      let combinedConfiguredItems = getCombinedData(questions, answers, 'configureditem');
      let validConfiguredItems = getValidConfiguredItems(combinedConfiguredItems);
      // Manually set the indexing for configured items to 80%
      validConfiguredItems = validConfiguredItems.map((configuredItem) => {
        return {...configuredItem, indexed: 80, percentDataSourcesIndexed: 80};
      });
      //Remove Business Analytics
      dsaAreaIds = dsaAreaIds.filter((id) => id !== 5);
      calculateAreaOverlap(overlap, dsaAreaIds, validConfiguredItems);
      return overlap;
    }
  );
};

const calculateAreaOverlap = (overlap, dsaAreaIds, validConfiguredItems) => {
  dsaAreaIds.forEach(areaId => {
    dsaAreaIds.filter(id => id !== areaId).forEach(otherId => {
      let areaConfiguredItems = validConfiguredItems.filter(item => item.overlap.indexOf(areaId) >= 0);
      let areaTotalData = getTotalDataPerDay(areaConfiguredItems);

      let overlapConfiguredItems = areaConfiguredItems.filter(item => item.overlap.indexOf(areaId) >= 0 && item.overlap.indexOf(otherId) >= 0);
      let overlapTotalIndexed = getTotalIndexed(overlapConfiguredItems);

      let otherConfiguredItems = validConfiguredItems.filter(item => item.overlap.indexOf(otherId) >= 0);

      overlap[areaId][otherId] = {
        areaItems: otherConfiguredItems.length,
        overlapItems: overlapConfiguredItems.length,
        totalIndexed: overlapTotalIndexed,
        overlapPercent: Math.round(overlapTotalIndexed / areaTotalData * 100) / 100 || 0,
        ciscoDataIndexed: overlapConfiguredItems.reduce((sum, item) => sum + getTotalIndexed([item]) * getCiscoRatio(item), 0),
        nonCiscoDataIndexed: overlapConfiguredItems.reduce((sum, item) => sum + getTotalIndexed([item]) * (1 - getCiscoRatio(item)), 0)
      };
    });
  });
};



// WEBPACK FOOTER //
// ./src/selectors/analytics/overlapSelectors.js